var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "root-container no-margin",
      style: { minWidth: _vm.minRootWidth, minHeight: _vm.minRootHeight },
    },
    [
      _c(
        "div",
        {
          class: { page: true, dragging: _vm.dragging },
          style: _vm.pageStyle,
          on: { mousemove: _vm.onMouseMove },
        },
        [
          _c(
            "div",
            {
              staticClass: "grid",
              class: { show: _vm.showGrid },
              style: _vm.innerContainerStyle,
            },
            [_vm._t("default")],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }